/**
 * Syncs the "Scheduled Gift Cards" app design selection to Horizon's media
 * gallery.
 *
 * The chosen design is a line-item property (`properties[_gift_card_design_id]`),
 * not a Shopify variant, so Horizon's variant -> media logic never fires. This
 * mirrors the old theme's `sgc:artwork:change` handler (which drove Flickity)
 * but drives Horizon's gallery: the event's `position` is the selected design's
 * index, which matches the product media order, so we select that slide.
 */
document.addEventListener('sgc:artwork:change', (event) => {
  const position = Number(/** @type {CustomEvent} */ (event).detail?.position);
  if (Number.isNaN(position)) return;

  // Scope to the gift-card PDP's own gallery: the design picker sits in the main
  // product section, so drive the `media-gallery` in that same section rather
  // than every one on the page (quick view, recommendations, secondary media…).
  const picker = document.querySelector('sgc-artwork-picker');
  const gallery =
    picker?.closest('.shopify-section')?.querySelector('media-gallery') ?? document.querySelector('media-gallery');
  if (!gallery) return;

  // `media-gallery` exposes a `slideshow` getter whose `select(index)` drives
  // the gallery; cast since querySelector types it as a generic Element.
  /** @type {any} */ (gallery).slideshow?.select(position, undefined, { animate: false });
});
